<template>
  <div class="consultation-container">
    <leave-message></leave-message>
  </div>
</template>

<script>
// import ConsultationGuidance from "./ConsultationGuidance";
// import PublicNumber from "./PublicNumber";
import LeaveMessage from "../../../home/LeaveMessage";
export default {
  name: "Index",
  components: {
    // ConsultationGuidance,
    // PublicNumber
    LeaveMessage
  }
};
</script>

<style lang="scss" scoped>
.consultation-container {

}
</style>
